import { CheckOutlined } from '@ant-design/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './FeaturesSection.module.scss'

const FeaturesSection: React.FC = () => {
    const { t } = useTranslation()
    const features: string[] = t('features.list', { returnObjects: true })

    return (
        <PageSection
            title={t('features.title')}
            style={{ backgroundColor: '#f4f2e8' }}
        >
            <ul className={cls.list}>
                {features.map((item, index) => (
                    <li key={index} className={cls.item}>
                        <CheckOutlined className={cls.check} aria-hidden />
                        <strong>{item}</strong>
                    </li>
                ))}
            </ul>
        </PageSection>
    )
}

export default FeaturesSection
